import { Modal as component } from ".";
import { MenuRoute } from "../../components/menu";

const name = "modal";

const state: MenuRoute = {
  name,
  abstract: true,
  views: {
    'overlay': {
      component,
    }
  },
  data: {
    title: 'Overlay',
    authed: true,
  },
};
export const OverlayRoutes = {
  state, name
}
